import React, { useState, useEffect } from "react";
import axios from "axios";
import { Spin } from "antd";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import "./teamModal.css";

const ViewTeamDetails = ({ teamId, setOpen }) => {
  const [teamData, setTeamData] = useState(null);
  const [country, setCountry] = useState(null);
  const teamsURL = process.env.REACT_APP_API_Team;
  const countryAPI = process.env.REACT_APP_API_Countries;

  useEffect(() => {
    const fetchTeamDetails = async () => {
      try {
        const response = await axios.get(`${teamsURL}/${teamId}`);
        setTeamData(response.data.body);
      } catch (error) {
        console.error("Error fetching team details:", error);
      }
    };

    fetchTeamDetails();
    return () => setTeamData(null);
  }, [teamId, teamsURL]);

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await axios.get(`${countryAPI}/${teamData.country_id}`);
        setCountry(response.data.body?.name || "—");
      } catch (error) {
        console.error("Error fetching country:", error);
        setCountry("—");
      }
    };

    if (teamData?.country_id) {
      fetchCountry();
    } else if (teamData) {
      setCountry("—");
    }
  }, [teamData, countryAPI]);

  if (!teamData) {
    return (
      <div className="team-modal-loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      <AppBar className="team-modal-appbar" position="relative">
        <Toolbar>
          <Typography className="team-modal-title" variant="h6" component="div" sx={{ flex: 1 }}>
            Team Details
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setOpen(false)}
            aria-label="close"
            className="team-modal-close-btn"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <div className="team-modal-body">
        <div className="team-detail-cards">
          <div className="team-detail-row">
            <span className="team-detail-label">Team ID</span>
            <span className="team-detail-value">{teamData.id}</span>
          </div>
          <div className="team-detail-row">
            <span className="team-detail-label">Team Name</span>
            <span className="team-detail-value">{teamData.name}</span>
          </div>
          <div className="team-detail-row">
            <span className="team-detail-label">Country</span>
            <span className="team-detail-value">
              {country === null ? (
                <Spin size="small" />
              ) : (
                country
              )}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewTeamDetails;
